import React from "react";
import { Box, Typography } from "@material-ui/core";
import { useSelectedTheme, useTranslate } from "../../../../../Hooks";
import moment from "moment";
import { CustomBadge, CustomCopyToClipboard } from "../../../../../Components";

import useStyles from "./styles";
import { fillTemplate, formatNumberWithCommas } from "../../../../../Helper";
import clsx from "clsx";
import { BedIcon, DotIcon } from "../../../../../assets/icons";

function InvoiceSummary({ invoice = {} }) {
  const {
    theme: { palette },
  } = useSelectedTheme();
  const {
    paymentTypeName,
    amountPaid,
    dueOn,
    amountDue,
    propertyName,
    bedrooms,
    unitId,
    invoiceStateName
  } = invoice;

  const badgeStyles = {
    paid: {
      BackgroundColor: palette.utility.success_50,
      BorderColor: palette.utility.success_200,
      Color: palette.utility.success_700,
    },
    pending: {
      BackgroundColor: palette.utility.warning_50,
      BorderColor: palette.utility.warning_200,
      Color: palette.utility.warning_700,
    },
    "partially paid": {
      BackgroundColor: palette.utility.warning_50,
      BorderColor: palette.utility.warning_200,
      Color: palette.utility.warning_700,
    },
    cancelled: {
      BackgroundColor: palette.utility.error_50,
      BorderColor: palette.utility.error_200,
      Color: palette.utility.error_700,
    },
    unpaid: {
      BackgroundColor: palette.utility.error_50,
      BorderColor: palette.utility.error_200,
      Color: palette.utility.error_700,
    },
  };

  const { translate } = useTranslate("AfterSalesClientProfileView");
  const styles = useStyles();

    const paidAmount = invoice.receipts.reduce((s, receipt) => s + receipt.netAmount, 0)

  return (
    <Box className={styles.container}>
      <Typography className={styles.invoiceTitle}>
        {fillTemplate(translate("invoice-details"), {
          date: moment(invoice?.createdOn).year(),
          id: invoice?.invoiceId,
        })}
      </Typography>
      <Box className={styles.field}>
        <Typography className={styles.label}>
          {translate("payment-type")}
        </Typography>
        <Typography className={styles.value} variant="body1">
          {paymentTypeName}
        </Typography>
      </Box>
      <Box className={styles.field}>
        <Typography className={styles.label}>
          {translate("property")}
        </Typography>
        <Typography className={styles.value} variant="body1">
          {propertyName}
        </Typography>
        <Box className={styles.iconContainer}>
          <Box className={styles.bedroomsDetails}>
            <BedIcon width={24} height={24} />
            <Typography
              className={clsx(styles.value, styles.numberOfBedrooms)}
              variant="body1"
            >
              {bedrooms}
            </Typography>
          </Box>
          <DotIcon fill={palette.border.main} width={6} height={6} />
          <CustomCopyToClipboard
            customContainerClasses={styles.copyToClipboard}
            data={unitId}
            childrenData={`#${unitId}`}
          />
        </Box>
      </Box>
      <Box className={styles.field}>
        <Typography className={styles.label}>{translate("amount")}</Typography>
        <Typography className={styles.value} variant="body1">
          {amountDue} AED
        </Typography>
      </Box>
      <Box className={styles.field}>
        <Typography className={styles.label}>
          {translate("due-date")}
        </Typography>
        <Typography className={styles.value} variant="body1">
          {moment(dueOn).format("DD MMM , YYYY")}
        </Typography>
        <Typography
          className={clsx(styles.value, styles.remainingAmmount)}
          variant="body1"
        >
          Remaining: {amountDue - paidAmount} AED
        </Typography>
      </Box>
      <CustomBadge
        label={invoiceStateName}
        value={invoiceStateName}
        className={clsx(styles.badge)}
        {...badgeStyles[invoiceStateName?.toLowerCase()]}
      />
    </Box>
  );
}

export default InvoiceSummary;
